import { createFileRoute } from '@tanstack/react-router';
import { TransactionalOverviewRouteView } from '@/pages/workspaces/transactional/message/overview/routing';

function TransactionalOverviewRoute() {
  const { transactionalMessageId } = Route.useParams();
  return <TransactionalOverviewRouteView transactionalMessageId={transactionalMessageId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/transactional_/$transactionalMessageId/overview',
)({
  component: TransactionalOverviewRoute,
});
